import React, { useEffect, useState, useCallback } from 'react';
import Select from 'react-select';
import { toast } from 'react-toastify';
import ApiService2 from '../../../../POS/services/apiService';
import ApiService from '../../../services/apiService';
import InvoiceItemList from '../invoiceItems';
import InvoiceGrnList from '../invoiceGrntable';
import { useLocation, useNavigate } from 'react-router-dom';
import AuthorizationInvoice from '../invoiceAuthorization';
import { useSelector } from 'react-redux';
import { getCompany, getName, getUserId, getUserName } from '../../../../Redux/selecters';
import { RiRefreshLine } from "react-icons/ri";
import { FaAngleLeft } from "react-icons/fa6";
import { FaSave } from "react-icons/fa";
import { ClipLoader } from 'react-spinners';
import Modal from 'react-bootstrap/Modal';
import Attachment from '../../Attachment/UpdateAttachment';
import { useCurrency } from '../../../../INVENTORY/Layouts/currencyContext';

const createEmptyRow = () => ({
    id: Date.now() + Math.random(),
    file: null,
    fileName: "",
    remarks: "",
});
const UpdateInvoice = () => {
    const [activeTab, setActiveTab] = useState(0);
    const [gridVisibility, setGridVisibility] = useState([true, false, false]);
    const apiService = new ApiService();
    const REPORT_URL = process.env.REACT_APP_REPORTS_URL
    const [messageData, setMessageData] = useState([]);
    const [loader, setLoader] = useState(false);
    const [authorizationData, setAuthorizationData] = useState([]);
    const [ItemData, setItemData] = useState([]);
    const [GrnItemData, setGrnItems] = useState([]);
    const [grnData, setGrnData] = useState([]);
    const { currencyPrecision } = useCurrency();
    const [grnMainList, setGrnList] = useState([]);
    const [selectedGrn, setSelectedGrn] = useState();
    const [SelectedCurrency, setSelectedCurency] = useState([]);
    const [POData, setPOData] = useState([]);
    const [usersDetails, setUser] = useState([]);
    const [PurchaseOrder, setPurchaseOrder] = useState([]);
    const [SelectedPO, setSelectedPO] = useState([]);
    const [invoiceNo, setInvoiceNo] = useState([]);
    const [SelectedSupplier, setSelectedSupplier] = useState([]);
    const userId = useSelector(getUserId);
    const userName = useSelector(getUserName);
    const Company = useSelector(getCompany);
    const currentDatetimeUTC = new Date().toISOString().slice(0, 16);
    const todayDate = new Date().toISOString().substr(0, 10);
    const [SupplierTab, setSupplierTab] = useState(true);
    const [loading, setLoading] = useState(false);
    const [POTab, setPOTab] = useState(true);
    const [CostTab, setCostTab] = useState(false);
    const [cost1, setCost1] = useState([]);
    const [cost2, setCost2] = useState([]);
    const [cost3, setCost3] = useState([]);
    const [cost4, setCost4] = useState([]);
    const [docModal, setDocModal] = useState(false);
    const onOpenModal = () => setDocModal(true);
    const onCloseModal = () => setDocModal(false);
    const [isVatExcluded, setIsVatExcluded] = useState(true);
    const [overallDiscount, setOverallDiscount] = useState(0);
    const [discountAmount, setDiscountAmount] = useState(0);
    const [grandTotal, setGrandTotal] = useState(0);
    const [vatAmount, setVatAmount] = useState(0);

    // Attachment
    const [attachmentModal, setAttachmentModal] = useState(false);
    const [previewModal, setPreviewModal] = useState(false);
    const [previewImage, setPreviewImage] = useState(null);
    const [attachments, setAttachments] = useState([createEmptyRow()]);
    const handleOpen = () => setAttachmentModal(true);
    const closeModal = () => setAttachmentModal(false);
    const isReadOnly = false;
    const location = useLocation();
    const itemData = location.state;

    const getCurrentLocalDatetime = () => {
        const localDate = new Date();
        const offset = localDate.getTimezoneOffset() * 60000;
        const localISOTime = new Date(localDate - offset).toISOString().slice(0, 16);
        return localISOTime;
    }
    const getCurrentDate = () => {
        return new Date().toISOString().split("T")[0]; // YYYY-MM-DD
    };

    const navigate = useNavigate();
    useEffect(() => {
        fetchData()
        getApprovalUser()
        setFormData({ ...formData, exchangeRate: currencyPrecision.conversionRate });
        if (currencyPrecision) {
            setSelectedCurency({ label: currencyPrecision.code, value: currencyPrecision });
        }
    }, [])
    const fetchData = async () => {
        setLoading(true)
        setInvoiceNo(itemData?.invoiceRegNo)
        const response = await apiService.get("GET_PO_INVOICE");
        setPurchaseOrder(response.data.result);
        let cost1 = await apiService.get('GET_COST_ONE')
        setCost1(cost1?.data?.result)
        let cost2 = await apiService.get('GET_COST_TWO')
        setCost2(cost2?.data?.result)
        let cost3 = await apiService.get('GET_COST_THREE')
        setCost3(cost3?.data?.result)
        let cost4 = await apiService.get('GET_COST_FOUR')
        setCost4(cost4?.data?.result)
        let InvData = itemData
        debugger
        let param = `?Id=${InvData?.pOrderNo}`
        const selectedPO = await apiService.getApiParamater("GET_PO", param);
        let selectedpurchase = selectedPO?.data?.result[0]

        if (selectedpurchase) {
            setIsVatExcluded(selectedpurchase?.costCenter5 === "excluded" ? true : false)
            setOverallDiscount(selectedpurchase?.discountPerc || 0);
            setLoading(false)
            setSelectedPO({ label: selectedpurchase?.pOrderNo, value: selectedpurchase?.pOrderNo })
            setSelectedSupplier({ label: selectedpurchase?.vendorName, value: selectedpurchase })
            setFormData({ ...formData, PurchaseOrderDate: selectedpurchase?.docDate });
            setFormData({ ...formData, PaymentTerm: selectedpurchase?.terms })
            setFormData({
                PurchaseOrderDate: selectedpurchase?.docDate,
                PaymentTerm: selectedpurchase?.terms,
                SuppInvoiceNo: InvData?.invoiceNo,
                InvoiceDate: InvData?.invoiceDate?.split("T")[0],
                DueDate: InvData?.dueDate?.split("T")[0],
                TaxInvoice: InvData?.costCenter5,
                Narration: InvData?.remarks,
                costCenter1: { label: selectedpurchase?.costCenter1 || '', value: selectedpurchase?.costCenter1 || '' },
                costCenter2: { label: selectedpurchase?.costCenter2 || '', value: selectedpurchase?.costCenter2 || '' },
                costCenter3: { label: selectedpurchase?.costCenter3 || '', value: selectedpurchase?.costCenter3 || '' },
                costCenter4: { label: selectedpurchase?.costCenter4 || '', value: selectedpurchase?.costCenter4 || '' },
            });
            setLoading(false)
            setPOData(selectedpurchase)
        }
    }
    const fetchItemsData = async (grnList) => {
        const selectedGrns = grnList.filter(grn => grn.checked === 1);
        let combinedGrn = {
            recordIds: [],
            requisitionDate: todayDate,
            invoiceNos: [],
            contractNos: [],
            remarks: [],
            requestors: [],
            currencyCodes: [],
            costCenters2: [],
            costCenters3: [],
            costCenters4: [],
            deliveryPoints: [],
            contactPersons: [],
            contactNos: [],
            taskCodes: [],
            locations: [],
            grnDetails: []
        };
        for (const selectedGrn of selectedGrns) {
            let param = `?Id=${selectedGrn?.grnNo}`
            const grnList = await apiService.getApiParamater("GET_GRN", param);
            setGrnList(grnList?.data?.result);
            let grnData = grnList?.data?.result[0]
            if (grnData) {
                combinedGrn.recordIds.push(grnData.grnNo);
                combinedGrn.invoiceNos.push(grnData.invoiceNo);
                combinedGrn.contractNos.push(grnData.contractNo);
                combinedGrn.remarks.push(grnData.remarks);
                combinedGrn.requestors.push(grnData.requestor);
                combinedGrn.currencyCodes.push(grnData.currencyCode);
                combinedGrn.costCenters2.push(grnData.costCenter2);
                combinedGrn.costCenters3.push(grnData.costCenter3);
                combinedGrn.costCenters4.push(grnData.costCenter4);
                combinedGrn.deliveryPoints.push(grnData.deliveryPoint);
                combinedGrn.contactPersons.push(grnData.contactPerson);
                combinedGrn.contactNos.push(grnData.contatNo);
                combinedGrn.taskCodes.push(grnData.projectCode);
                combinedGrn.locations.push(grnData.warehouse);
                combinedGrn.grnDetails = [...combinedGrn.grnDetails, ...grnData.grnDetails];
            }
        }

        setSelectedGrn(selectedGrns || []);
        setFormData({
            ...formData,
            recordIds: combinedGrn.recordIds.join(', '),
            invoiceNo: combinedGrn.invoiceNos.join(', '),
            contractNo: combinedGrn.contractNos.join(', '),
            remarks: combinedGrn.remarks.join(', '),
            requestor: combinedGrn.requestors.join(', '),
            currencyCode: combinedGrn.currencyCodes.join(', '),
            costCenter2: combinedGrn.costCenters2.join(', '),
            costCenter3: combinedGrn.costCenters3.join(', '),
            costCenter4: combinedGrn.costCenters4.join(', '),
            deliveryPoint: combinedGrn.deliveryPoints.join(', '),
            contactPerson: combinedGrn.contactPersons.join(', '),
            contactNo: combinedGrn.contactNos.join(', '),
            taskCode: combinedGrn.taskCodes.join(', '),
            location: combinedGrn.locations.join(', '),
        });
        if (combinedGrn.grnDetails.length === 0) {
            setGrnItems();
        } else {
            setGrnItems(combinedGrn.grnDetails || null);
        }

    }
    const getApprovalUser = async () => {
        try {
            const params = new URLSearchParams();
            params.append('DocNo', '');
            params.append('DocumentType', "Invoice");
            const response = await apiService.getApiParamater('GET_DOC_STATUS_EDIT', `?${params.toString()}`);
            setUser(response.data.result);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }
    const handleTabClick = (tabIndex) => {
        setActiveTab(tabIndex);
        const newGridVisibility = gridVisibility.map((_, index) => index === tabIndex);
        setGridVisibility(newGridVisibility);
    }
    const handleMessage = (data) => {
        setMessageData(data);
        console.log(data, 'reqData')

    }
    const handleRequisitionData = (data) => {
        setItemData(data);
        console.log(data, 'reqData')
    }
    const GrnData = (data) => {
        setGrnData(data);
        fetchItemsData(data)
        console.log(data, 'grnData')
    }
    const handleAuthorization = (data) => {
        setAuthorizationData(data);
        console.log(data, 'reqData')

    }
    const [formData, setFormData] = useState({
        InvoiceNO: "",
        remarks: "",
        InvoiceDate: getCurrentDate(),
        deliveryDate: getCurrentDate(),
        PaymentTerm: "",
        POType: "",
        SuppInvoiceNo: "",
        Department: "",
        Currency: "",
        exchangeRate: "",
        DueDate: getCurrentDate(),
        TaxInvoice: "",
        CostCentre5: "",
        Narration: "",
        costCenter1: "",
        costCenter2: "",
        costCenter3: "",
        costCenter4: "",
    })
    const CreateInvoice = async () => {
        setLoader(true)

        if (!SelectedPO?.label) {
            toast.warning("Please enter Purchase Order No.");
            setLoader(false)
            return;
        }
        if (selectedGrn?.length === 0) {

            toast.warning("Please Select Grn For Invoice Creation");
            setLoader(false)
            return;
        }
        if (ItemData?.length === 0) {
            toast.warning("Please add items");
            setLoader(false)
            return;
        }
        if (!formData?.SuppInvoiceNo) {
            toast.warning("Please enter Supp Invoice No");
            setLoader(false)
            return;
        }
        if (!formData?.InvoiceDate) {
            toast.warning("Please enter Supp Invoice Date");
            setLoader(false)
            return;
        }
        try {
            const currentDatetimeUTC = new Date().toISOString();
            const apiService = new ApiService();
            const totalAmount = ItemData.reduce((sum, row) => sum + (row?.amount || 0), 0);
            const invoiceRegDetails = ItemData?.map((item, index) => {
                const selectedGrn = grnData?.find(rec => rec.grnNo === item.grnNo);
                let amount = parseFloat(item.amount)
                debugger
                return {
                    itemCode: item?.ItemNo,
                    itemDescription: item.itemDescription,
                    uom: item.uom,
                    qty: parseFloat(item.qty),
                    baseUOM: item?.uom,
                    baseQty: item.qty,
                    budgetCode: '',
                    specification: item.specification,
                    unitPrice: item.unitPrice.toFixed(currencyPrecision || 3),
                    amount: parseFloat(amount),
                    baseAmount: parseFloat(amount),
                    vatAmount: parseFloat(item.vatAmount).toFixed(currencyPrecision || 3),
                    convToInvUOM: item.stock,
                    isActive: true,
                    srno: item?.srno,
                    vatPerc: item.vat,
                    grnNo: selectedGrn?.grnNo,
                };
            }).filter(item => item);
            const body = {
                rcNo: itemData?.rcNo,
                // attention: "string",
                // fax: "string",
                // quotationRef: "string",
                // contractNo: "string",
                // deliveryPoint: "string",
                // contactPerson: "string",
                // state: "string",
                // diffAmount: 0,
                // grnNo: "string",
                // batchNo: "string",
                // nvType: "string",
                // diffAcCode: "string",

                invoiceNo: formData?.SuppInvoiceNo,
                invoiceRegNo: invoiceNo,
                // invoiceRef: formData?.SuppInvoiceNo,
                invoiceDate: formData?.InvoiceDate || currentDatetimeUTC,
                pOrderNo: SelectedPO.label,
                vendorId: SelectedSupplier?.value?.vendorId,
                vendorName: SelectedSupplier.label,
                docDate: formData?.InvoiceDate || currentDatetimeUTC,
                location: formData?.location,
                costCenter1: formData?.costCenter1?.label,
                costCenter2: formData?.costCenter2?.label,
                costCenter3: formData?.costCenter3?.label,
                costCenter4: formData?.costCenter4?.label,
                costCenter5: formData.TaxInvoice,
                currencyCode: SelectedCurrency.label,
                exchangeRate: SelectedCurrency?.value.conversionRate,
                terms: SelectedSupplier?.value?.terms,
                department: SelectedSupplier?.value?.department,
                aprrovalUser: authorizationData?.userNo,
                modifiedOn: currentDatetimeUTC,
                modifiedBy: userName,
                status: 0,
                remarks: formData.Narration,
                dueDate: formData.DueDate,
                isActive: true,
                isEditable: 0,
                invoiceRegDetails: invoiceRegDetails,
                baseAmount: (grandTotal - vatAmount),
                amount: grandTotal,
            };
            debugger
            const response = await apiService.put("UPDATE_INVOICE", body);
            if (response?.data?.statusCode === 201) {
                setLoader(false)
                toast.success(`${invoiceNo} Created successfully`);
                navigate("/Inventory/invoice/List");
            } else if (response?.data?.statusCode === 208) {
                setLoader(false)
                onOpenModal()
            }
        } catch (error) {
            setLoader(false)
            console.error("Error Creating issue:", error);
        }
    }

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [e.target.name]: e.target.value });

        if (name === "InvoiceDate") {
            const newDueDate = calculateDueDate(
                value,
                formData.PaymentTerm
            );
            setFormData((prevFormData) => ({
                ...prevFormData,
                DueDate: newDueDate,
            }));
        }
    }

    const calculateDueDate = (invoiceDate, paymentTerm) => {
        if (!paymentTerm) return "";

        // Extract number of days from payment term
        // "60 Days Post Dated Cheque after Invoice" => 60
        const match = paymentTerm.match(/(\d+)\s*Days?/i);

        if (!match) return "";

        const days = parseInt(match[1], 10);

        // If invoiceDate is not available, use today's date
        let date;

        if (invoiceDate) {
            const dateString = String(invoiceDate).split(" ")[0];

            // Handle MM/DD/YYYY
            if (dateString.includes("/")) {
                const [month, day, year] = dateString.split("/").map(Number);

                date = new Date(year, month - 1, day);
            }
            // Handle YYYY-MM-DD
            else if (dateString.includes("-")) {
                const [year, month, day] = dateString.split("-").map(Number);

                date = new Date(year, month - 1, day);
            }
        }

        // If date could not be parsed, use today
        if (!date || isNaN(date.getTime())) {
            date = new Date();
        }

        // Add payment term days
        date.setDate(date.getDate() + days);

        // Format for datetime-local
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");

        return `${year}-${month}-${day}`;
    };
    const handlePoChange = async (selectedOption) => {
        let param = `?Id=${selectedOption?.label}`
        const selectedPO = await apiService.getApiParamater("GET_PO", param);
        let selectedpurchase = selectedPO?.data?.result[0]

        if (selectedpurchase) {
            setSelectedPO({ label: selectedpurchase?.pOrderNo, value: selectedpurchase?.pOrderNo })
            setSelectedSupplier({ label: selectedpurchase?.vendorName, value: selectedpurchase })
            setFormData({ ...formData, PurchaseOrderDate: selectedpurchase?.docDate });
            setFormData({ ...formData, PaymentTerm: selectedpurchase?.terms })
            setFormData({
                PurchaseOrderDate: selectedpurchase?.docDate,
                PaymentTerm: selectedpurchase?.terms,
                costCenter1: { label: selectedpurchase?.costCenter1 || '', value: selectedpurchase?.costCenter1 || '' },
                costCenter2: { label: selectedpurchase?.costCenter2 || '', value: selectedpurchase?.costCenter2 || '' },
                costCenter3: { label: selectedpurchase?.costCenter3 || '', value: selectedpurchase?.costCenter3 || '' },
                costCenter4: { label: selectedpurchase?.costCenter4 || '', value: selectedpurchase?.costCenter4 || '' },
            });
            setPOData(selectedpurchase)
        }
    }
    const handleBackClick = () => {
        window.history.back();
    }
    const handleCost1 = async (selectedOption) => {
        let param = `?CostCenter1=${selectedOption?.label}`
        let cost2 = await apiService.getApiParamater('GET_COST_TWO', param)
        if (cost2?.data?.result) {
            setCost2([{ value: null, description: 'None' }, ...cost2?.data?.result]);
        } else {
            setCost2([])
        }
        setFormData({ ...formData, costCenter1: selectedOption });
    }
    const handleCost2 = (selectedOption) => {
        setFormData({ ...formData, costCenter2: selectedOption });
    }
    const handleCost3 = (selectedOption) => {
        setFormData({ ...formData, costCenter3: selectedOption });
    }
    const handleCost4 = (selectedOption) => {
        setFormData({ ...formData, costCenter4: selectedOption });
    }
    // Attachment Functions
    const handleFileSelect = useCallback((file, id) => {
        setAttachments((prev) => {
            const updated = prev.map((row) =>
                row.id === id ? { ...row, file, fileName: file.name } : row
            );
            return [...updated, createEmptyRow()];
        });
    }, []);
    const handleRemarkChange = (id, value) => {
        setAttachments((prev) =>
            prev.map((row) =>
                row.id === id ? { ...row, remarks: value } : row
            )
        );
    };
    const handleDelete = (id) => {
        setAttachments((prev) => prev.filter((row) => row.id !== id));
    };
    const handleView = (file) => {
        if (!file) return;
        if (isReadOnly) {
            setPreviewImage(file);
        } else {
            setPreviewImage(URL.createObjectURL(file));
        }
        setPreviewModal(true);
    };
    const handleUpload = async (name, docNo) => {
        const formData = new FormData();

        attachments.forEach(({ file }) => {
            if (file instanceof File) {
                formData.append("Images", file, file.name);
            }
        });

        const response = await apiService.postMultiPart(
            "UPLOAD_FILE",
            formData
        );

        if (response?.data?.statusCode === 201 && response?.data?.isSuccessful) {
            const uploadedFileNames = response.data.result.split(",");

            const payload = {
                docFilesDtos: attachments
                    .filter((a) => a.file)
                    .map((a, index) => ({
                        srno: index + 1,
                        docNo: docNo,
                        docType: name,
                        fileName: uploadedFileNames[index]?.trim(),
                        remarks: a.remarks || "",
                    })),
            };

            await apiService.post("CREATE_ATTACHMENT", payload);
            return
        }
    };
    return (
        <div className='px-4'>

            <div className='d-flex justify-content-between pt-3'>
                <h5 className='col mainInvHead'>Supplier Invoice</h5>
                <div className='d-flex gap-3'>
                    {loader === true ?
                        <button className='mainbtn ' type="submit"><ClipLoader color="#ffffff" size={25} /></button> :
                        <button className='mainbtn ' type="submit" onClick={CreateInvoice}><FaSave className='center mt-1 mx-2' /><div>Update</div></button>
                    }
                    <button className='mainbtnRed' ><RiRefreshLine className='center mt-1 mx-2' /><div>Reset</div></button>
                    <button onClick={handleBackClick} className='mainbtnSecondary'><FaAngleLeft className='center mt-1 mx-2' /><div>Back</div></button>
                </div>
            </div>
            <div className="cost-center-section">
                <div className="d-flex mt-3 cursor-pointer slide-header"
                    onClick={() => setPOTab(!POTab)}>
                    <div className='h6 pt-1'>Invoice Details</div>
                </div>
                <div className={`slide-content ${POTab ? 'open' : 'closed'}`}>
                    {loading && (
                        <div
                            style={{
                                position: 'absolute',
                                inset: 0,
                                background: 'rgba(255,255,255,0.6)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                zIndex: 10,
                            }}
                        >
                            <div className="spinner-border text-primary" role="status" />
                        </div>
                    )}
                    <div className={`border-box2 p-3 ${POTab ? 'slide-in' : 'slide-out'}`}>
                        <div className="form-group row pb-3">
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="InvoiceNO" className="form-label  pt-1 start">Invoice No</label>
                                <input
                                    className="form-Input w-70"
                                    id="invoiceNo"
                                    value={invoiceNo}
                                    name="invoiceNo"
                                    disabled
                                />
                            </div>
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="deliveryDate" className="form-label  pt-1 start">Date </label>
                                <input className='form-Input w-70' type='date'
                                    name="deliveryDate"
                                    id="deliveryDate"
                                    value={formData.deliveryDate}
                                    min={getCurrentLocalDatetime()}
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="POType" className="form-label  pt-1 start">PO Type</label>
                                <input
                                    type="text"
                                    className="form-Input w-70"
                                    id="POType"
                                    value={formData.POType}
                                    onChange={handleInputChange}
                                    name="POType"
                                />
                            </div>
                        </div>
                        <div className="form-group row pb-3">
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="InvoiceDate" className="form-label  pt-1 start">Supp. Invoice Date *</label>
                                <input
                                    type="date"
                                    className="form-Input w-70"
                                    id="InvoiceDate"
                                    value={formData?.InvoiceDate}
                                    // min={getCurrentLocalDatetime()}
                                    onChange={handleInputChange}
                                    name="InvoiceDate"
                                />
                            </div>
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="inventoryAccountCode" className="form-label  pt-1 start">Supplier Name</label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    className="w-70 p-0"
                                    value={SelectedSupplier}
                                />
                            </div>
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="PaymentTerm" className="form-label  pt-1 start">Payment Term</label>
                                <input
                                    type="text"
                                    className="form-Input w-70"
                                    id="PaymentTerm"
                                    value={formData.PaymentTerm}
                                    onChange={handleInputChange} disabled

                                    name="PaymentTerm"
                                />
                            </div>
                        </div>
                        <div className="form-group row  pb-3">
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="inventoryAccountCode" className="form-label  pt-1 start">Purchase Order No *</label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    className="w-70 p-0"
                                    value={SelectedPO}
                                    options={PurchaseOrder?.map((po) => ({ value: po?.pOrderNo, label: po?.pOrderNo }))}
                                    onChange={(selectedOption) => handlePoChange(selectedOption)}
                                />
                            </div>
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="SuppInvoiceNo" className="form-label  pt-1 start">Supp. Invoice No* </label>
                                <input
                                    type="text"
                                    className="form-Input w-70"
                                    id="SuppInvoiceNo"
                                    value={formData.SuppInvoiceNo}
                                    onChange={handleInputChange}
                                    name="SuppInvoiceNo"
                                />
                            </div>
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="DueDate" className="form-label  pt-1 start">Due Date</label>
                                <input
                                    type="date"
                                    className="form-Input w-70"
                                    id="DueDate"
                                    value={formData.DueDate}
                                    onChange={handleInputChange}
                                    name="DueDate"
                                />
                            </div>
                        </div>
                        <div className="form-group row pb-3">
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="TaxInvoice" className="form-label  pt-1 start">Tax Invoice No  (KRA)</label>
                                <input
                                    type="number" onWheel={(e) => e.target.blur()}
                                    className="form-Input w-70"
                                    id="TaxInvoice"
                                    value={formData.TaxInvoice}
                                    onChange={handleInputChange}
                                    name="TaxInvoice"
                                />
                            </div>
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="Currency" className="form-label  pt-1 start">Currency</label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    className="w-70 p-0"
                                    isSearchable={false}
                                    value={SelectedCurrency}
                                />
                            </div>
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="EXRate" className="form-label  pt-1 start">EX Rate</label>
                                <input
                                    type="number"
                                    className="form-Input w-70"
                                    disabled
                                    onWheel={(e) => e.target.blur()}
                                    id="exchangeRate"
                                    value={formData.exchangeRate}
                                    onChange={handleInputChange}
                                    name="exchangeRate"
                                />
                            </div>
                        </div>
                        <div className="form-group row">
                            <div className="d-flex justify-content-between col-4">
                                <label htmlFor="Narration" className="form-label  pt-1 start">Narration</label>
                                <input
                                    type="text" onWheel={(e) => e.target.blur()}
                                    className="form-Input w-70"
                                    id="Narration"
                                    value={formData.Narration}
                                    onChange={handleInputChange}
                                    name="Narration"
                                />
                            </div>
                            <div className='col-1 px-5 mx-3'></div>
                            <div className="col-2 brderbox center" onClick={() => handleOpen()} >
                                {'Attachment'}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="cost-center-section">
                <div className="d-flex mt-3 cursor-pointer slide-header"
                    onClick={() => setSupplierTab(!SupplierTab)}>
                    <div className='h6 pt-1'>GRN Details</div>
                </div>
                <div className={`slide-content ${SupplierTab ? 'open' : 'closed'}`}>
                    <div className="border-box2">
                        <div className="grid-1">
                            <InvoiceGrnList GrnData={GrnData} itemData={itemData} SelectedPO={SelectedPO.value} currencyPrecision={currencyPrecision?.precision || 3} />
                        </div>
                    </div>
                </div>
            </div>
            <div className="cost-center-section">
                <div className="d-flex mt-3 cursor-pointer slide-header" onClick={() => setCostTab(!CostTab)}>
                    <div className="h6 pt-1">Cost Center Details</div>
                </div>
                <div className={`slide-content ${CostTab ? 'open' : 'closed'}`}>
                    <div className="border-box2 p-3">
                        <div className="form-group row pb-3">
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="PropertyGroup" className="form-label  pt-1 start">Property</label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    className="w-70 p-0"
                                    value={formData.costCenter1}
                                    onChange={handleCost1}
                                    options={cost1?.map((sup) => ({ value: sup, label: sup?.description }))}
                                />
                            </div>
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="Property" className="form-label  pt-1 start">Unit</label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    className="w-70 p-0" value={formData.costCenter2}
                                    onChange={handleCost2}
                                    options={cost2?.map((sup) => ({ value: sup, label: sup?.description }))}
                                />
                            </div>
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="Department" className="form-label  pt-1 start">Cost Center 3</label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    className="w-70 p-0" value={formData.costCenter3}
                                    onChange={handleCost3}
                                    options={cost3?.map((sup) => ({ value: sup, label: sup?.description }))}
                                />
                            </div>
                        </div>
                        <div className="form-group row">
                            <div className="d-flex justify-content-between col-4">
                                <label htmlFor="Outlet" className="form-label  pt-1 start">Cost Center 4</label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    className="w-70 p-0" value={formData.costCenter4}
                                    onChange={handleCost4}
                                    options={cost4?.map((sup) => ({ value: sup, label: sup?.description }))}
                                />
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <div className="slide-container p-2 mt-3">
                <div className="container-fluid">
                    <div className="nav nav-pills overslid d-flex gap-4">
                        {/* Nav tabs */}
                        <div
                            className={`dashitems sidebar-text center ${activeTab === 0 ? 'sideActive' : ''}`}
                            onClick={() => handleTabClick(0)}
                        >
                            Items
                        </div>
                        <div
                            className={`dashitems sidebar-text center  ${activeTab === 1 ? 'sideActive' : ''}`}
                            onClick={() => handleTabClick(1)}
                        >
                            Authorization
                        </div>
                        <div
                            className={`dashitems sidebar-text center  ${activeTab === 2 ? 'sideActive' : ''}`}
                            onClick={() => handleTabClick(2)}
                        >
                            Message
                        </div>
                    </div>
                </div>
            </div>
            <div className="grid-1 brderbox2 p-4 mb-3">
                {gridVisibility[0] && (
                    <InvoiceItemList onRequisitionData={handleRequisitionData} GrnItemData={GrnItemData} currencyPrecision={currencyPrecision?.precision || 3} setIsVatExcluded={setIsVatExcluded} isVatExcluded={isVatExcluded} setVatAmount={setVatAmount}
                        setOverallDiscount={setOverallDiscount} overallDiscount={overallDiscount} setDiscountAmount={setDiscountAmount} vatAmount={vatAmount}
                        discountAmount={discountAmount} setGrandTotal={setGrandTotal} grandTotal={grandTotal} />
                )}
                {gridVisibility[1] && (
                    <AuthorizationInvoice handleAuthorization={handleAuthorization}
                        usersDetails={usersDetails}
                        setUser={setUser}
                        itemData={POData} />
                )}
                {gridVisibility[2] && (
                    <div className="grid-3 border">
                        {/* <MessageGrid handleMessage={handleMessage} /> */}
                    </div>
                )}
            </div>
            <div>
                <Attachment
                    open={attachmentModal}
                    onClose={closeModal}
                    documentNo={invoiceNo}
                    rows={attachments}
                    readOnly={isReadOnly}
                    onFileSelect={handleFileSelect}
                    onRemarkChange={handleRemarkChange}
                    onDelete={handleDelete}
                    onView={handleView}
                    onSave={handleUpload}
                    previewImage={previewImage}
                    previewOpen={previewModal}
                    closePreview={() => setPreviewModal(false)}
                />
            </div>
        </div >
    )
}

export default UpdateInvoice